import React, { useState, useRef, useEffect } from 'react';
import ReactDOM from 'react-dom';
import app from './app';
import Sortable from 'sortablejs';
import {MenuModel,ConfirmModal} from "../components/helpers";
import {svgIcon} from "./utility";


const menuActionList = [
  //{ "type": "addFeature", "text": "Add Feature Page" },
  { "type": "link", "text": "link", "icon" : "links" },
  { "type": "rename", "text": "rename",  "icon" : "rename" },
  { "type": "addSubmenu", "text": "add_submenu" ,  "icon" : "addSubmenu" },
  { "type": "moveUnderTop", "text": "move_under_top" ,  "icon" : "moveUnderTop" },
  //{ "type": "moveUp", "text": "Move Up" ,  "icon" : "moveUp" },
  { "type": "moveDown", "text": "move_down",  "icon" : "moveDown" },
  { "type": "moveOutside", "text": "move_outside" ,  "icon" : "moveOutside"},
  { 
    "type": "submenuLayout", 
    "text": "submenu_layout", 
    "icon" : "submenuLayout",
    "options": [
      { "value": "1", "text": "list" },
      { "value": "2", "text": "grid" }
    ],
    "sizeOptions": [
      { "value": "1", "text": "1" },
      { "value": "2", "text": "2" },
      { "value": "3", "text": "3" },
      { "value": "4", "text": "4" }
    ]
  },
  { "type": "remove", "text": "remove",  "icon" : "remove" }
]

const ActionList = function({index, subIndex, callback, badgeClick, data, updateGrid, haveSubMenu,menu,subMenu}) {
  return  <div className="action menu-sort-dropdown">
  <span className="" onClick={badgeClick}>
      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 22 22" fill="none">
      <circle cx="11" cy="11" r="10.5" fill="#EBF5FD" stroke="#3899ED"/>
      <path d="M16.3174 9.625C16.6955 9.625 17.0192 9.75967 17.2884 10.029C17.5577 10.2982 17.6924 10.6219 17.6924 11C17.6924 11.3781 17.5577 11.7018 17.2884 11.971C17.0192 12.2403 16.6955 12.375 16.3174 12.375C15.9393 12.375 15.6155 12.2403 15.3462 11.971C15.077 11.7018 14.9424 11.3781 14.9424 11C14.9424 10.6219 15.077 10.2982 15.3462 10.029C15.6155 9.75967 15.9393 9.625 16.3174 9.625ZM11.0289 9.625C11.407 9.625 11.7307 9.75967 11.9999 10.029C12.2692 10.2982 12.4039 10.6219 12.4039 11C12.4039 11.3781 12.2692 11.7018 11.9999 11.971C11.7307 12.2403 11.407 12.375 11.0289 12.375C10.6508 12.375 10.3271 12.2403 10.0579 11.971C9.78858 11.7018 9.6539 11.3781 9.6539 11C9.6539 10.6219 9.78858 10.2982 10.0579 10.029C10.3271 9.75967 10.6508 9.625 11.0289 9.625ZM5.74042 9.625C6.11855 9.625 6.44229 9.75967 6.71163 10.029C6.98083 10.2982 7.11542 10.6219 7.11542 11C7.11542 11.3781 6.98083 11.7018 6.71163 11.971C6.44229 12.2403 6.11855 12.375 5.74042 12.375C5.3623 12.375 5.03864 12.2403 4.76945 11.971C4.5001 11.7018 4.36542 11.3781 4.36542 11C4.36542 10.6219 4.5001 10.2982 4.76945 10.029C5.03864 9.75967 5.3623 9.625 5.74042 9.625Z" fill="#3899ED"/>
      </svg>
  </span>
  <div className="overlay-drop" style={{display: "none"}}></div>
  <ul className="list-group dropdown-wrap">
    {
      menuActionList.map(function(v){
        if(haveSubMenu !== 0) {
          if(v.type === "moveUnderTop") {
            return null;
          }
        }
        if(index === 0) {
          if(v.type === "moveUnderTop") {
            return null;
          }
        }
        if(subIndex === undefined) {
          if(v.type === "moveOutside") {
            return null;
          }
          if(v.type === "submenuLayout" && haveSubMenu) {
            return <li className="submenu-layout-options">
              <a href="javascript:void(0)" className="dropdown-item">
              <i class={`me-2`}>{svgIcon[`${v.icon}`]}</i>
               {app.getLang(v.text)} </a>

            <div className="item-groups">  
              <div className="item">
                <h6>{app.getLang("menu_type")}</h6>
                <div className="d-flex gap-2 item-groups">  
                  <div className="item flex-1 mb-0">  
                    <select className="form-select form-select-sm" data-index={index} data-key="type" onChange={updateGrid}>
                      {
                        v.options.map(function(v){
                        return <option value={v.value}>{app.getLang(v.text)}</option>
                        })
                      }
                    </select>
                  </div>
                  <div className={`item flex-1 mb-0 ${data.properties?(data.properties.type === "2"?"":"d-none"):"d-none"}`}>
                    <select className={`form-select form-select-sm ${data.properties?(data.properties.type === "2"?"":"d-none"):"d-none"}`} data-index={index} data-key="size" onChange={updateGrid}>
                      {
                        v.sizeOptions.map(function(v){
                          return <option value={v.value}>{v.text}</option>
                        })
                      }
                    </select>
                  </div>
                </div>
              </div>
              {/* <div className={`item ${data.properties?(data.properties.type === "2"?"":"d-none"):"d-none"}`}>
                <h6>Grids</h6>
               
              </div> */}
            </div>
 
           

            </li>
          }
        }
        
        else {
          if(v.type === "submenuLayout") {
            return null;
          }
          if(v.type === "moveUnderTop") {
            return null;
          }
        }

        if( Array.isArray(menu) && index === menu.length - 1 || 
            Array.isArray(subMenu) && subIndex === subMenu.length - 1){
          if(v.type === "moveDown"){
            return null;
          }
        }
        if(v.type === "submenuLayout" && !haveSubMenu){
          return null;
        }
        if(v.type === "addSubmenu" && subIndex !== undefined){
          return null;
        }
        
        return <li><a href="javascript:void(0)" type="button" data-type={v.type} className="dropdown-item" onClick={() => callback(v.type, index, subIndex)}>
          <i class={`me-2`}>
            {svgIcon[`${v.icon}`]}
          </i>
          {app.getLang(v.text)}
          
        </a>
        </li>
      })
    }
  </ul>
  </div>
}

export const MasterMenuTemp = function(){
  const [menu, setMenu] = useState([])
  useEffect(() => {
    document.querySelector("button").addEventListener("click", function(){
      alert("done")
    });
    
  }, []);

  useEffect(() => {
    setInterval(function(){
      setMenu((prev)=>[...prev,"menu"]);
    }, 2000);
  }, []);

  return <div>Ravi Kumar <button>hello</button>
  <br />
  {menu.map(function(v){
  return <div>{v}</div>
  })}
  </div>
}
export const MasterMenu = function({data, edit, callback}){
  const [menu, setMenu] = useState(data.navigationMenu? data.navigationMenu:[]);


  const rootInfo = useRef(null);


  useEffect(()=>{
    var all = document.querySelectorAll('.main-list-group');
    all.forEach(function(v){
      Sortable.create(v, {
        handle: '.handle', // handle's class
        animation: 150,
        onEnd: function(e) {
          setTimeout(function(){
            sortMainMenu();
          }, 100);
          console.log("main done");
        }
      });
    })

    var all2 = document.querySelectorAll('.sub-list-group');
    all2.forEach(function(v){
      Sortable.create(v, {
        handle: '.handle', // handle's class
        animation: 150,
        onEnd: function(e) {
          setTimeout(function(){
            sortMainMenu(e);
          },100)
          //console.log("sortMainMenu");
          // write steps which you want to perform after sorting
        }
      });
    });
    data["navigationMenu"] = menu;
    callback(data);
  },[menu]);

  useEffect(() => {
    //Runs only on the first render
    updateOptionsDom();
    // document.querySelectorAll(".main-menu, .sub-menu").forEach(function(v){
    //   const title = v.querySelector(".title");
    //   const button = v.querySelector("button.done");
    //   title.addEventListener("click", function(){
    //     document.querySelectorAll(".main-menu, .sub-menu").forEach(function(el){
    //       el.classList.remove("edit");
    //     });
    //   });
    //   title.addEventListener("dblclick", function(){
    //     title.removeEventListener("click", function(){
    //       document.querySelectorAll(".main-menu, .sub-menu").forEach(function(el){
    //         el.classList.remove("edit");
    //       });
    //     });
    //     v.classList.add("edit");
    //   });
    //   button.addEventListener("click", function(e){
    //     v.classList.remove("edit");
    //     title.addEventListener("click", function(){
    //       document.querySelectorAll(".main-menu, .sub-menu").forEach(function(el){
    //         el.classList.remove("edit");
    //       });
    //     });
    //   })
    // });

  });

  const updateOptionsDom = () => {

    document.querySelectorAll(".main-menu, .sub-menu").forEach(function(v){
      const title = v.querySelector(".title");
      const button = v.querySelector("button.done");
      const renameOption = v.querySelector(`.dropdown-item[data-type="rename"]`);

      title.addEventListener("click", function(){
        document.querySelectorAll(".main-menu, .sub-menu").forEach(function(el){
          el.classList.remove("edit");
        });
      });
      title.addEventListener("dblclick", function(){
        title.removeEventListener("click", function(){
          document.querySelectorAll(".main-menu, .sub-menu").forEach(function(el){
            el.classList.remove("edit");
          });
        });
        v.classList.add("edit");
      });
      button.addEventListener("click", function(e){
        v.classList.remove("edit");
        title.addEventListener("click", function(){
          document.querySelectorAll(".main-menu, .sub-menu").forEach(function(el){
            el.classList.remove("edit");
          });
        });
      });
      renameOption.addEventListener("click", function(){
        document.querySelectorAll(".main-menu, .sub-menu").forEach(function(el){
          el.classList.remove("edit");
        });
        v.classList.add("edit");
      });
    });

    // console.log("Test....",event);
    // document.querySelectorAll(".main-menu, .sub-menu").forEach(function(v){
    //   const renameOption = v.querySelector(`.dropdown-item[data-type="rename"]`);
    //   // console.log(renameOption,"renameOption----");
    //   renameOption.addEventListener("click", function(){
    //     document.querySelectorAll(".main-menu, .sub-menu").forEach(function(el){
    //       el.classList.remove("edit");
    //     });
    //     v.classList.add("edit");
    //   });
    // });

  }

  const sortMainMenu = function(ele) {
    if(ele) {
      const allDB = [...ele.target.querySelectorAll(".list-item-sub")].map(function(v){
        return v.getAttribute("data-id");;
      });
      setMenu(function(prevMenu){
        return [...prevMenu].map((v,i)=>{
          if(parseInt(ele.target.getAttribute("data-index")) === i) {
            v.data = v.data.sort((a, b) => allDB.indexOf(a.id) - allDB.indexOf(b.id));
          }
          return v;
        })
      });
    }
    else {
      const allDB = [...document.querySelectorAll(".list-item-main")].map(function(v){
        return v.getAttribute("data-id");;
      });
      setMenu(function(prevMenu){
        return [...prevMenu].sort((a, b) => allDB.indexOf(a.id) - allDB.indexOf(b.id))
      });
    }
  }

  const badgeClick = function(event) {
    updateOptionsDom();
    const obj = event.currentTarget;
    const objParent = obj.parentElement;
    const customMenuOptions = objParent.querySelector(".menu-sort-dropdown .dropdown-wrap");
    const rect = obj.getBoundingClientRect();
    const overlay = objParent.querySelector(".overlay-drop");

    overlay.style.display = "block";
    overlay.addEventListener('click',(e) => {
      // console.log("overlay clicked",e.currentTarget);
      let elem = e.currentTarget
      elem.style.display = "none";
      obj.parentElement.classList.remove("active");
      obj.parentElement.parentElement.classList.remove("li-active");
    })

    // Close other open dropdowns
    document.querySelectorAll(".action").forEach(function(e){
      e.classList.remove("active");
      e.parentElement.classList.remove("li-active");
    })

    // Activate current dropdown
    obj.parentElement.classList.add("active");
    obj.parentElement.parentElement.classList.add("li-active");

    // Position dropdown
    const windowHeight = window.innerHeight
    const customMenuOptionsPos = customMenuOptions.offsetHeight + rect.top + 30;
    const customMenuSetBottom = windowHeight - rect.bottom;
    // console.log("customMenuSetBottom === ", customMenuSetBottom);
    customMenuOptions.style.left = `${rect.left + 35}px`;
    if(customMenuOptionsPos >= windowHeight){
      customMenuOptions.style.bottom = `${customMenuSetBottom - 15}px`; 
      customMenuOptions.style.top = `unset`; 
      customMenuOptions.classList.add("caret-bottom");
    }else{
      customMenuOptions.style.top = `${rect.top - 10}px`; 
      customMenuOptions.style.bottom = `unset`; 
      customMenuOptions.classList.remove("caret-bottom");
    }
  }

  const renameMenu = function(value, index, subIndex){
    setMenu(menu.map(function(v, i){
      if(i === index) {
        if(subIndex !== undefined) {
          v.data[subIndex].title = value;
        }
        else {
          v.title = value;
        }
        
      }
      return v;
    }))

  } 
  
  const updateGrid = function(event){
    const key = event.currentTarget.getAttribute("data-key");
    const index = event.currentTarget.getAttribute("data-index");
    const value = event.currentTarget.value;
    setMenu(function(prevMenu){
      return prevMenu.map(function(v, i){
        if(parseInt(index) === i) {
          if(!v["properties"]) {
            v["properties"] = {};
          }
          v["properties"][key] = value;
        }
        
        return v;
      })
    })
    console.log(event.currentTarget.getAttribute("data-index"), event.currentTarget.getAttribute("data-key"))
  }
  const updateMenu = function(type, index, subIndex){
    if(type === "remove") {
      if(subIndex !== undefined) {
        setMenu(function(prevMenu){
          return prevMenu.map(function(v, i){
            if(i === index) {
              v.data = v.data.filter(function(ele, ind){
                if(ind === subIndex) {
                  return false;
                }
                return true;
              })
            }
            return v;
          })
        });
        
      }
      else {
        setMenu(function(prevMenu){
          return prevMenu.filter(function(v, i){
            if(i === index) {
              return false;
            }
            return true;
          })
        });
      }
      document.querySelectorAll(".action").forEach(function(e){
        e.classList.remove("active");
        e.parentElement.classList.remove("li-active");
      })
    }
    if(type === "moveOutside") {
      
      setMenu(function(prevMenu){
        const item = JSON.parse(JSON.stringify(prevMenu[index].data[subIndex]));
        item["data"] = [];
        return [...prevMenu.map(function(v, i){
          if(i === index) {
            v.data = v.data.filter(function(val, ind){
              if(ind === subIndex) {
                return false
              }
              return true;
            })
          }
          return v;
        }), item];
      });
      document.querySelectorAll(".action").forEach(function(e){
        e.classList.remove("active");
        e.parentElement.classList.remove("li-active");
      })
    }
    if(type === "moveUnderTop") {
      setMenu(function(prevMenu){
        prevMenu[index - 1].data.push(JSON.parse(JSON.stringify(prevMenu[index])));
        return prevMenu.filter(function(v, i){
          if(i === index) {
            return false;
          }
          return true;
        });
      })
    }
    if(type === "moveUp" || type === "moveDown") {
      if(subIndex !== undefined) {
        setMenu((prevMenu) => {
          const newMenu = [...prevMenu]; // Copy the main array
          const dataCopy = [...newMenu[index].data]; // Copy the nested `data` array
      
          const newSubIndex = type === "moveUp" ? subIndex - 1 : subIndex + 1;
      
          // Ensure new index is within bounds
          if (newSubIndex < 0 || newSubIndex >= dataCopy.length) return prevMenu;
      
          // Swap items in the `data` array
          [dataCopy[subIndex], dataCopy[newSubIndex]] = [dataCopy[newSubIndex], dataCopy[subIndex]];
      
          // Update the main array with the modified `data` array
          newMenu[index] = { ...newMenu[index], data: dataCopy };
      
          return newMenu;
        });
      }
      else {
        setMenu((prevMenu) => {
          const newMenu = [...prevMenu]; // Create a new array to avoid mutation
      
          // Determine the new index
          const newIndex = type === "moveUp" ? index - 1 : index + 1;
      
          // Ensure new index is within bounds
          if (newIndex < 0 || newIndex >= newMenu.length) return prevMenu;
      
          // Swap items
          [newMenu[index], newMenu[newIndex]] = [newMenu[newIndex], newMenu[index]];
      
          return newMenu;
        });
      }
      
 
      
      document.querySelectorAll(".action").forEach(function(e){
        e.classList.remove("active");
        e.parentElement.classList.remove("li-active");
      })
    }
    if(type === "link") {
      //console.log(menu);
      if(subIndex !== undefined)  {
        menuPopup(menu[index].data[subIndex], index, subIndex);
      }
      else {
        menuPopup(menu[index], index);
      }
      document.querySelectorAll(".action").forEach(function(e){
        e.classList.remove("active");
        e.parentElement.classList.remove("li-active");
      })
    }
    if(type === "addSubmenu") {
      setMenu((prevMenu) => {
        const updatedMenu = [...prevMenu]; // Create a shallow copy of the array
        updatedMenu[index] = {
          ...updatedMenu[index], 
          data: [
            ...updatedMenu[index].data, 
            { title: "untitled", type: "none", value: "", id: Date.now() }
          ]
        };
        return updatedMenu;
      });
      document.querySelectorAll(".action").forEach(function(e){
        e.classList.remove("active");
        e.parentElement.classList.remove("li-active");
      })
    }
    if(type === "mainMenu") {
      setMenu(function(prevMenu){
        return [...prevMenu, {
          title:"untitled",
          type:"none",
          value:"",
          id:`${Date.now()}`,
          data:[]
        }]
      });
      
    }
    if(type === "rename") {
      updateOptionsDom();
      // if(subIndex) {
      //   menuPopup(menu[index].data[subIndex], index, subIndex);
      // }
      // else {
      //   menuPopup(menu[index], index);
      // }
    }
    document.querySelectorAll(".overlay-drop").forEach((items) => {
      items.style.display = "none";
    });
 
  } 
  const updateValue = function(data, index, subIndex) {
    setMenu(function(prevMenu){
      return prevMenu.map(function(v, i){
        if(index === i) {
          if(subIndex !== undefined) {
            v["data"] = v.data.map(function(val, ind){
              if(subIndex === ind) {
                val["type"] = data.type;
                val["value"] = data.value;
              }
              return val;
            });
          }
         else {
          v["type"] = data.type;
          v["value"] = data.value;
         }
        }
       
        return v;
      });
    
    });

  }
  const menuPopup = function (data, index, subIndex) {
   
    const div = document.createElement("div");
    document.body.appendChild(div);
    ReactDOM.render(<MenuModel data={data} index={index} subIndex={subIndex} update={updateValue} />, div);
  }

  const collapseSubMenu = (e) => {
    const element = e.currentTarget;
    let listItem = element.parentElement.parentElement;
    let isCollapsed = listItem.getAttribute("data-collapse");
    listItem.setAttribute('data-collapse' , isCollapsed !== "true");
  }

  // when below cloneMenu will work fine then we remove this commented code

  // const cloneMenu =function(e){
  //   if(e.currentTarget.checked) {
  //     data.properties["customMenu"] =true;
  //     let cloneMenu = false;
  //     if(data["navigationMenu"]) {
  //       if(data["navigationMenu"].length === 0) {
  //         cloneMenu = true;
  //       }
  //     }
  //     else {
  //       cloneMenu = true;
  //     }
  //     console.log(data["navigationMenu"], cloneMenu);
  //     if(cloneMenu) {
  //       if(localStorage.getItem("featurePages")) {
  //         data["navigationMenu"] = JSON.parse(localStorage.getItem("featurePages")).map(function(v){
  //           let pageId = v.pageId.replace("_", "").replace("_", "");
  //           let pageValue = `javascript:opendeeplinkpage('${pageId}://')`;
  //           let folders = [];
  //           if(v.folderPages) {
  //             folders = v.folderPages.map(function(val){
  //               let folderPageId = val.pageId.replace("_", "").replace("_", "");
  //               return {
  //                 id:`${pageId}_folderPageId`,
  //                 title:val.pageName,
  //                 type:"page",
  //                 value:`javascript:opendeeplinkpage('${pageId}://$$${folderPageId}://`,
  //               }
  //             });
  //           }
  //           return {
  //             id:pageId,
  //             title:v.pageName,
  //             type:"page",
  //             value:pageValue,
  //             data:folders
  //           }
  //         });
  //         setMenu(data["navigationMenu"]);
  //       }
  //     }
  //   }
  //   else {
  //     data.properties["customMenu"] =false;
  //   }
  //   callback(data)
  // }

  const cloneMenu =function(){
    let cloneMenu = false;
    if(data["navigationMenu"]) {
      if(data["navigationMenu"].length === 0) {
        cloneMenu = true;
      }
    }
    else {
      cloneMenu = true;
    }
    console.log(data["navigationMenu"], cloneMenu,"clone_menu_function_running");

    if(cloneMenu) {
      if(localStorage.getItem("featurePages")) {
        data["navigationMenu"] = JSON.parse(localStorage.getItem("featurePages")).map(function(v){
          let pageId = v.pageId.replace("_", "").replace("_", "");
          //let pageValue = `javascript:opendeeplinkpage('${pageId}://')`;
          let pageValue = `/${v.pageUrl}`;
          if(v.pageIdentifier === "home") {
            pageValue = "/";
          }
          let folders = [];
          if(v.folderPages) {
            folders = v.folderPages.map(function(val){
              let folderPageId = val.pageId.replace("_", "").replace("_", "");
              return {
                id:`${pageId}_${folderPageId}`,
                title:val.pageName,
                type:"page",
                //value:`javascript:opendeeplinkpage('${pageId}://$$${folderPageId}://')`,
                value:`/${v.pageUrl}/${val.pageUrl}`,
              }
            });
          }
          return {
            id:pageId,
            title:v.pageName,
            type:"page",
            value:pageValue,
            data:folders
          }
        });
        setMenu(data["navigationMenu"]);
      }
    }
    callback(data)
  }
  
  const enableCustomMenu = (e) => {
    const isChecked = e.target.checked;
    // console.log("isChecked=====",isChecked);

    if(isChecked){
      const div = document.createElement("div");
      let title = app.getLang("enable_custom_menu");
      let summary = app.getLang("enable_custom_menu_summary");
      document.body.appendChild(div);


      const onConfirm = () => {
        data.properties["customMenu"] = true;
        callback(data)
        cloneMenu();
      }

      const onCancel = () => {
        data.properties["customMenu"] = false;
        callback(data)
      }

      ReactDOM.render(<ConfirmModal title={title} summary={summary} onConfirm={onConfirm} onCancel={onCancel}/>, div);  
      
    }else{
      data.properties["customMenu"] = false;
      callback(data)
    }
  }


  return <div ref={rootInfo} className="w-100 pt-1" style={{height:"100%"}}>
   <div className="form-check hide-list form-switch border-top-0 px-4" data-id="">
    <label className="form-check-label m-0">{app.getLang("enable_custom_menu")}</label>
    {/* <input type="checkbox" className="form-check-input ms-auto mt-0" checked={data.properties["customMenu"] === true?true:false} onChange={cloneMenu} /> */}
    <input type="checkbox" className="form-check-input ms-auto mt-0" checked={data.properties["customMenu"] === true?true:false} onChange={enableCustomMenu} />
  </div>

  <h6 className={`fw-bold mt-3 px-4 ${data.properties["customMenu"] === true?"":"d-none"}`}>{app.getLang("menu_items")}</h6>

  <div className="menu-sortable-wrappper">
    <ul className="list-group action-list">
      {
        menuActionList.map(function(v){
          // if(subIndex === undefined) {
          //   if(v.type === "moveOutside") {
          //     return null;
          //   }
          // }
          // else {
          //   if(v.type === "submenuLayout") {
          //     return null;
          //   }
          // }
          return <button type="button" data-type={v.type} className="list-group-item list-group-item-action">
            {v.text}
          </button>
        })
      }
    </ul>
    
    <div className={`menu-sortable-box ${data.properties["customMenu"] === true?"":"d-none"}`}>
      <ul class="list-group main-list-group" id="list-group">
        {
          menu.map(function(v, i){
            let subMenu = "";
            let haveSubMenu = 0;
            if(v.data) {
              haveSubMenu = v.data.length;
              subMenu = <ul class="list-group sub-list-group" data-index={i}>
                  {
                    v.data.map(function(e, ind){
                    return <li class={`list-group-item list-item-sub sub-menu d-flex ${ ind === 0 ? "first-item" : ind === v.data.length - 1 ? "last-item" : "" }`} data-index={i} data-subIndex={ind} data-id={v.id}>
                        <div className="menu-drag-box">
                          <span className="handle">
                            <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
                            <path d="M1.50034 13.3459C1.1302 13.3459 0.813324 13.2141 0.549713 12.9505C0.286102 12.6869 0.154297 12.37 0.154297 11.9998C0.154297 11.6297 0.286102 11.3128 0.549713 11.0492C0.813324 10.7856 1.1302 10.6538 1.50034 10.6538C1.87048 10.6538 2.18735 10.7856 2.45096 11.0492C2.71457 11.3128 2.84638 11.6297 2.84638 11.9998C2.84638 12.37 2.71457 12.6869 2.45096 12.9505C2.18735 13.2141 1.87048 13.3459 1.50034 13.3459ZM6.50034 13.3459C6.1302 13.3459 5.81332 13.2141 5.54971 12.9505C5.2861 12.6869 5.1543 12.37 5.1543 11.9998C5.1543 11.6297 5.2861 11.3128 5.54971 11.0492C5.81332 10.7856 6.1302 10.6538 6.50034 10.6538C6.87048 10.6538 7.18735 10.7856 7.45096 11.0492C7.71457 11.3128 7.84638 11.6297 7.84638 11.9998C7.84638 12.37 7.71457 12.6869 7.45096 12.9505C7.18735 13.2141 6.87048 13.3459 6.50034 13.3459ZM1.50034 8.34589C1.1302 8.34589 0.813324 8.21409 0.549713 7.95047C0.286102 7.68686 0.154297 7.36999 0.154297 6.99985C0.154297 6.62971 0.286102 6.31284 0.549713 6.04922C0.813324 5.78561 1.1302 5.65381 1.50034 5.65381C1.87048 5.65381 2.18735 5.78561 2.45096 6.04922C2.71457 6.31284 2.84638 6.62971 2.84638 6.99985C2.84638 7.36999 2.71457 7.68686 2.45096 7.95047C2.18735 8.21409 1.87048 8.34589 1.50034 8.34589ZM6.50034 8.34589C6.1302 8.34589 5.81332 8.21409 5.54971 7.95047C5.2861 7.68686 5.1543 7.36999 5.1543 6.99985C5.1543 6.62971 5.2861 6.31284 5.54971 6.04922C5.81332 5.78561 6.1302 5.65381 6.50034 5.65381C6.87048 5.65381 7.18735 5.78561 7.45096 6.04922C7.71457 6.31284 7.84638 6.62971 7.84638 6.99985C7.84638 7.36999 7.71457 7.68686 7.45096 7.95047C7.18735 8.21409 6.87048 8.34589 6.50034 8.34589ZM1.50034 3.34589C1.1302 3.34589 0.813324 3.21409 0.549713 2.95047C0.286102 2.68686 0.154297 2.36999 0.154297 1.99985C0.154297 1.62971 0.286102 1.31284 0.549713 1.04922C0.813324 0.785614 1.1302 0.653809 1.50034 0.653809C1.87048 0.653809 2.18735 0.785614 2.45096 1.04922C2.71457 1.31284 2.84638 1.62971 2.84638 1.99985C2.84638 2.36999 2.71457 2.68686 2.45096 2.95047C2.18735 3.21409 1.87048 3.34589 1.50034 3.34589ZM6.50034 3.34589C6.1302 3.34589 5.81332 3.21409 5.54971 2.95047C5.2861 2.68686 5.1543 2.36999 5.1543 1.99985C5.1543 1.62971 5.2861 1.31284 5.54971 1.04922C5.81332 0.785614 6.1302 0.653809 6.50034 0.653809C6.87048 0.653809 7.18735 0.785614 7.45096 1.04922C7.71457 1.31284 7.84638 1.62971 7.84638 1.99985C7.84638 2.36999 7.71457 2.68686 7.45096 2.95047C7.18735 3.21409 6.87048 3.34589 6.50034 3.34589Z" fill="#82869B"/>
                            </svg>
                          </span>
                          <div className="mid-part">
                            <div className="w-100 input-group">
                              <input type="text" className="form-control mt-0" value={e.title} placeholder="Menu Text" onInput={function(e){
                              renameMenu(e.currentTarget.value, i, ind)
                              }}/>
                              <button className="btn btn-primary done" type="button">done</button>
                            </div>

                            <span className="w-100 title">{e.title}</span>
                          </div>

                          <ActionList key={`root${i}`} index={i} subMenu={v.data} subIndex={ind} badgeClick={badgeClick} callback={function(type, index, subIndex){
                          //alert(`${type}, ${index}, ${subIndex}`)
                          updateMenu(type, index, subIndex)
                          }} />

                        </div>
                      </li>
                    })
                  }
              </ul>
            }
            return <li className={`list-group-item list-item-main ${ i === 0 ? "first-item" : i === menu.length - 1 ? "last-item" : "" }`} data-index={i} data-id={v.id} data-collapse="false">
              <div className="main-menu d-flex menu-drag-box">
                <span class="handle">
                  <svg xmlns="http://www.w3.org/2000/svg" width="8" height="14" viewBox="0 0 8 14" fill="none">
                  <path d="M1.50034 13.3459C1.1302 13.3459 0.813324 13.2141 0.549713 12.9505C0.286102 12.6869 0.154297 12.37 0.154297 11.9998C0.154297 11.6297 0.286102 11.3128 0.549713 11.0492C0.813324 10.7856 1.1302 10.6538 1.50034 10.6538C1.87048 10.6538 2.18735 10.7856 2.45096 11.0492C2.71457 11.3128 2.84638 11.6297 2.84638 11.9998C2.84638 12.37 2.71457 12.6869 2.45096 12.9505C2.18735 13.2141 1.87048 13.3459 1.50034 13.3459ZM6.50034 13.3459C6.1302 13.3459 5.81332 13.2141 5.54971 12.9505C5.2861 12.6869 5.1543 12.37 5.1543 11.9998C5.1543 11.6297 5.2861 11.3128 5.54971 11.0492C5.81332 10.7856 6.1302 10.6538 6.50034 10.6538C6.87048 10.6538 7.18735 10.7856 7.45096 11.0492C7.71457 11.3128 7.84638 11.6297 7.84638 11.9998C7.84638 12.37 7.71457 12.6869 7.45096 12.9505C7.18735 13.2141 6.87048 13.3459 6.50034 13.3459ZM1.50034 8.34589C1.1302 8.34589 0.813324 8.21409 0.549713 7.95047C0.286102 7.68686 0.154297 7.36999 0.154297 6.99985C0.154297 6.62971 0.286102 6.31284 0.549713 6.04922C0.813324 5.78561 1.1302 5.65381 1.50034 5.65381C1.87048 5.65381 2.18735 5.78561 2.45096 6.04922C2.71457 6.31284 2.84638 6.62971 2.84638 6.99985C2.84638 7.36999 2.71457 7.68686 2.45096 7.95047C2.18735 8.21409 1.87048 8.34589 1.50034 8.34589ZM6.50034 8.34589C6.1302 8.34589 5.81332 8.21409 5.54971 7.95047C5.2861 7.68686 5.1543 7.36999 5.1543 6.99985C5.1543 6.62971 5.2861 6.31284 5.54971 6.04922C5.81332 5.78561 6.1302 5.65381 6.50034 5.65381C6.87048 5.65381 7.18735 5.78561 7.45096 6.04922C7.71457 6.31284 7.84638 6.62971 7.84638 6.99985C7.84638 7.36999 7.71457 7.68686 7.45096 7.95047C7.18735 8.21409 6.87048 8.34589 6.50034 8.34589ZM1.50034 3.34589C1.1302 3.34589 0.813324 3.21409 0.549713 2.95047C0.286102 2.68686 0.154297 2.36999 0.154297 1.99985C0.154297 1.62971 0.286102 1.31284 0.549713 1.04922C0.813324 0.785614 1.1302 0.653809 1.50034 0.653809C1.87048 0.653809 2.18735 0.785614 2.45096 1.04922C2.71457 1.31284 2.84638 1.62971 2.84638 1.99985C2.84638 2.36999 2.71457 2.68686 2.45096 2.95047C2.18735 3.21409 1.87048 3.34589 1.50034 3.34589ZM6.50034 3.34589C6.1302 3.34589 5.81332 3.21409 5.54971 2.95047C5.2861 2.68686 5.1543 2.36999 5.1543 1.99985C5.1543 1.62971 5.2861 1.31284 5.54971 1.04922C5.81332 0.785614 6.1302 0.653809 6.50034 0.653809C6.87048 0.653809 7.18735 0.785614 7.45096 1.04922C7.71457 1.31284 7.84638 1.62971 7.84638 1.99985C7.84638 2.36999 7.71457 2.68686 7.45096 2.95047C7.18735 3.21409 6.87048 3.34589 6.50034 3.34589Z" fill="#82869B"/>
                  </svg>
                </span>
                <span className={`collapse-menu-btn ${ v.data && v.data.length === 0 && 'd-none'}`} onClick={collapseSubMenu}>
                  <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                    <path d="M12.0004 14.6537L7.59668 10.25H16.4042L12.0004 14.6537Z" fill="#5F6368"/>
                  </svg>
                </span>
                <div className="mid-part">
                  <div className="input-group">
                    <input type="text" className="form-control mt-0" value={v.title} placeholder="Menu Text" onInput={function(e){
                      renameMenu(e.currentTarget.value, i)
                    }} />
                    <button className="btn btn-primary done" type="button">done</button>
                  </div>
                  <span className="title">{v.title}</span>
                </div>
                <ActionList key={`root${i}`} index={i} badgeClick={badgeClick} callback={function(type, index){
                  updateMenu(type, index)
                }} updateGrid={updateGrid} data={v} menu={menu} haveSubMenu={haveSubMenu} />
              </div>
              {subMenu}
            </li>
          })
        }
      </ul>
    </div>
    
    <div className={`menu-sort-footer ${data.properties["customMenu"] === true?"":"d-none"}`}>
        <a href="javascript:void(0)" className="mt-1 link-text text-decoration-none d-flex align-items-center" onClick={() => updateMenu("mainMenu")}>
        <svg xmlns="http://www.w3.org/2000/svg" className="mx-1" height="20px" viewBox="0 -960 960 960" width="20px" fill="#3899ED"><path d="M440-440H200v-80h240v-240h80v240h240v80H520v240h-80v-240Z"/></svg>
        {app.getLang("add_item")}</a>
    </div>


  </div>


  

</div>

}